import { cn } from '@/lib/utils';
import { formatChange, type ChangeMarker as Marker } from '@/lib/assessment/examTrends';

type T = (key: string) => string;

const COLOR = {
  better: 'text-green-700',
  worse: 'text-red-600',
  neutral: 'text-muted-foreground',
} as const;

/**
 * The change of an indicator since the previous exam (#112): «↓ 0.8», «↑ 3»,
 * «— ثابت» or «أول قياس»; green toward the good level, red away from it.
 */
export function ChangeMarker({ change, t, className }: { change: Marker; t: T; className?: string }) {
  const text =
    change.kind === 'first'
      ? t('common.health.report.first')
      : change.kind === 'same'
        ? `— ${t('common.health.report.same')}`
        : formatChange(change);
  const tone = change.kind === 'changed' ? COLOR[change.direction] : COLOR.neutral;
  const label =
    change.kind === 'changed'
      ? `${t(`common.health.report.direction.${change.direction}`)} ${text} ${t('common.health.report.sincePrevious')}`
      : text;
  return (
    <span
      className={cn('text-xs font-medium whitespace-nowrap', tone, className)}
      data-testid="change-marker"
      data-direction={change.kind === 'changed' ? change.direction : change.kind}
      aria-label={label}
      title={label}
    >
      <bdi dir={change.kind === 'changed' ? 'ltr' : undefined}>{text}</bdi>
    </span>
  );
}
